import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, OnDestroy, ChangeDetectorRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { Eye, EyeDisabled } from '../icon/icon-map';

@Component({
  selector: 'phx-password-input',
  exportAs: 'phxPasswordInput',
  templateUrl: './phx-password-input.component.html',
  styleUrls: ['./phx-password-input.component.scss'],
  host: {
    class: 'phx-password-input',
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhxPasswordInput),
      multi: true,
    },
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxPasswordInput implements ControlValueAccessor, OnDestroy {
  @Input() public phxDisabled: boolean = false;

  public isTextHidden: boolean = true;
  public phxPasswordValue: string;
  public readonly eyeIcon = Eye;
  public readonly disabledEyeIcon = EyeDisabled;

  private _destroy$ = new Subject<void>();
  private _onChange: (value: any) => void = () => {};
  private _onTouched: () => void = () => {};

  constructor(private cdr: ChangeDetectorRef) { }

  public onEyeIconClick(): void {
    if (!this.phxDisabled) {
      this.isTextHidden = !this.isTextHidden;
    }
  }

  public onPasswordChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.phxPasswordValue = target.value;
    this._onChange(this.phxPasswordValue);
  }

  public onBlur(): void {
    this._onTouched();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public writeValue(value: any): void {
    this.phxPasswordValue = value;
    this.cdr.markForCheck();
  }

  public registerOnChange(fn: (value: any) => void): void {
    this._onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }
}
